var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#E6FBF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9197 17.8096C14.6213 17.5224 14.1465 17.5314 13.8592 17.8299C13.572 18.1283 13.5811 18.6031 13.8795 18.8903L16.425 21.3403L16.9621 21.8574L17.4823 21.3233L22.9369 15.7233C23.2259 15.4266 23.2196 14.9517 22.9229 14.6627C22.6262 14.3737 22.1514 14.3799 21.8623 14.6767L16.928 19.7426L14.9197 17.8096ZM17.9996 25.65C13.7746 25.65 10.3496 22.225 10.3496 18C10.3496 13.775 13.7746 10.35 17.9996 10.35C22.2246 10.35 25.6496 13.775 25.6496 18C25.6496 22.225 22.2246 25.65 17.9996 25.65Z",
    stroke: "#1BC46F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/GreenCheck.ae1d280fba9d2c5ae0063e842342498a.svg";
export { ForwardRef as ReactComponent };